<template>
</template>

<script>
import {defineComponent, onMounted} from 'vue'

export default defineComponent({
  name: 'WechatH5WechatOfficialAccountLogin',
  props: {
    method: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    onMounted(() => {
      //const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${props.method.options.appid}&redirect_uri=${props.method.options.redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${props.method.options.state}#wechat_redirect`
      const url = new URL('https://open.weixin.qq.com/connect/oauth2/authorize');
      url.searchParams.append('appid', props.method.options.appid);
      url.searchParams.append('redirect_uri', props.method.options.redirect_uri);
      url.searchParams.append('response_type', 'code');
      url.searchParams.append('scope', 'snsapi_userinfo');
      props.method.options.state ? url.searchParams.append('state', props.method.options.state) : null;
      url.hash = 'wechat_redirect';
      location.href = url.toString();
    })

    return {}
  }
})
</script>

<style scoped>
</style>
